
    <div class="video-iframe-container" (dblclick)="divdblClick($event)" (click)="divClick($event)">
          <!-- <iframe  id="iframe-id" [src]="urlSafe" allow="autoplay" donotallowfullscreen></iframe> -->
          <div id="frame-id"></div>
          <div #videocontainer id="videocontainer"></div>
          <div class="video-iframe-box">
            <div id="video-iframe-container" class="video-iframe-container" [ngClass]="{'fullscreenMode':videoFullscreenStatus}">
              <span class="yt-logo-overlay"></span>
              <iframe id="iframe-id" [src]="urlSafe" allow="autoplay" donotallowfullscreen></iframe>
              <div #videocontainer id="videocontainer">
                <button class="UNAPP-yt-fullscreen-btn exitFullScreen sm" *ngIf="videoFullscreenStatus" (click)="exitFullScreen()"><img src="assets/img/fullscreen-exit-icon.svg" /></button>
              </div>
            </div>
            <button class="UNAPP-yt-fullscreen-btn sm" *ngIf="!videoFullscreenStatus" (click)="showFullScreen()"><img src="assets/img/fullscreen-icon-2.svg" /></button>
          </div>
    </div>
